export default __webpack_public_path__ + "static/media/event-calendar.685f74fc.svg";